import React from 'react';

import Helper from '../../../lib/Helper';

import styles from './Indications.module.css';

const IndicationFull = (props) => (

  <div className={styles.indicationFull}>
    <div className={styles.subject}>
     {props.indication?.ref} &nbsp;
     {props.indication?.pat_relation > 1 ? '(Kind)' : null}
    </div>
    <div className={styles.bodyFull}>
      Befund vom {Helper.PrintDate(props.indication?.created_at)}<br />
      <div className={styles.paragraph}>
        Einwilligungen:<br />
        Kontaktierung für Therapien: {props.indication?.accept_therapy ? 'Ja' : 'Nein'}<br />
        Kontaktierung für Studien: {props.indication?.accept_studies ? 'Ja' : 'Nein'}<br />
        Kontaktierung bei Re-Evaluation: {props.indication?.accept_reevaluation ? 'Ja' : 'Nein'}<br />
      </div>
      <div className={styles.paragraph}>
        Einverständniserklärung <br />
        {props.indication?.sig_place}, den {Helper.PrintDate(props.indication?.sig_date)}<br />

        <img style={{width:'100px'}} src={"data:image/svg+xml;base64," + props.indication?.sig_img} alt="Card image cap" /><br />
        ({props.indication?.sig_first_name} {props.indication?.sig_name})
      </div>
    </div>
  </div>
);

export default IndicationFull;